import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icon6.png'
import _imports_1 from '../assets/icon7.png'
import _imports_2 from '../assets/icon8.png'
import _imports_3 from '../assets/icon9.png'
import _imports_4 from '../assets/icon10.png'
import _imports_5 from '../assets/icon11.png'
import _imports_6 from '../assets/icon12.png'


const _withScopeId = n => (_pushScopeId("data-v-4811a6c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-danger mt-5 d-flex align-self-center flex-column text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "root"
}
const _hoisted_3 = {
  class: "nav nav-tabs fixed-top bg-white ps-2 pt-1 pe-2",
  style: {"margin-top":"40px"}
}
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "d-flex flex-fill justify-content-end" }
const _hoisted_8 = ["onSelect", "value"]
const _hoisted_9 = {
  class: "pt-2 container p-0",
  style: {"margin-top":"25px"}
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "text-end" }
const _hoisted_13 = { class: "me-3" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg" }
const _hoisted_16 = { class: "card mt-2 mt-lg-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header card-header-exam" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h4" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "exam-icon"
    }),
    /*#__PURE__*/_createTextVNode(" あなたの口腔状態は ")
  ])
], -1))
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-8 p-3 d-flex flex-column" }
const _hoisted_21 = { class: "d-flex flex-row" }
const _hoisted_22 = { class: "flex-fill" }
const _hoisted_23 = { class: "h1 text-white" }
const _hoisted_24 = { class: "mt-3" }
const _hoisted_25 = { class: "col-4 p-0" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "col-lg" }
const _hoisted_28 = { class: "card mt-3 mt-lg-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header card-header-exam" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h4" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "exam-icon"
    }),
    /*#__PURE__*/_createTextVNode(" 歯科推定年齢 ")
  ])
], -1))
const _hoisted_30 = { class: "card-body" }
const _hoisted_31 = { class: "d-flex justify-content-center" }
const _hoisted_32 = { class: "d-flex flex-column" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  class: "h2",
  style: {"line-height":"10px"}
}
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 2 }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, " 歯科推定年齢は歯科健診データを基にオリジナルで算出した年齢です。 ", -1))
const _hoisted_40 = { class: "card mt-3" }
const _hoisted_41 = { class: "card-header card-header-exam" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "exam-icon"
  }),
  /*#__PURE__*/_createTextVNode(" 歯の状態 ")
], -1))
const _hoisted_43 = {
  class: "position-absolute text-end pt-2 pe-2",
  style: {"top":"0px","left":"0px","width":"100%"}
}
const _hoisted_44 = { class: "card-body" }
const _hoisted_45 = {
  key: 0,
  class: "table table-sm c-table-bordered"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", {
    style: {"width":"100px"},
    class: "bg-light"
  }, "記号"),
  /*#__PURE__*/_createElementVNode("th", { class: "bg-light" }, "説明")
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "Co"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "初期の虫歯で要観察のもの")
], -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "C1"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "虫歯１度　歯の表面だけか歯の中の部分に少しだけ虫歯が進行したのもで、痛みを感じない")
], -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "C2"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "虫歯２度　歯の中の部分に虫歯が進行したもので、水や冷たいものがしみる")
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "C3"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "虫歯３度　神経まで虫歯が進んだもので、ひどく痛むことが多い")
], -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "C4"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "虫歯４度　歯の大部分が侵食され、歯の根元だけが残っている状態")
], -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "IIC"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "治療の済んだ歯に、虫歯がもう一度できてしまったした状態")
], -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "破折"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "歯牙の一部分が虫歯以外の理由でかけている状態")
], -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "脱落"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "治療していた部分が取れてしまった状態（虫歯になっていない）")
], -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "WSD"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "歯の根元がすり減ったりへこんだりした状態　主に歯の磨き方が悪くて歯にできるクサビ状の凹み")
], -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "X"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "歯が抜けてしまったところのことで、補う必要がある部分")
], -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "17",
      height: "17",
      class: "m-0"
    }, [
      /*#__PURE__*/_createElementVNode("g", { transform: "scale(0.7)" }, [
        /*#__PURE__*/_createElementVNode("ellipse", {
          fill: "none",
          stroke: "#000000",
          "stroke-miterlimit": "10",
          cx: "6.9",
          cy: "7.15",
          rx: "6.36",
          ry: "6.594"
        }),
        /*#__PURE__*/_createElementVNode("line", {
          fill: "none",
          stroke: "#000000",
          "stroke-miterlimit": "10",
          x1: "2.379",
          y1: "2.5",
          x2: "11.555",
          y2: "11.677"
        }),
        /*#__PURE__*/_createElementVNode("line", {
          fill: "none",
          stroke: "#000000",
          "stroke-miterlimit": "10",
          x1: "2.2",
          y1: "11.67",
          x2: "11.338",
          y2: "2.532"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "欠損はしているが、補う必要がない部分")
], -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "m"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "モビリティー　グラグラしている歯のこと")
], -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "AF"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "銀色の詰め物を入れた歯　虫歯にアマルガム（水銀の合金）をつめたもの")
], -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "AFIIC"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "AF の処置歯に虫歯がもう一度できてしまったした状態")
], -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "In"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "インレー　虫歯に金属の詰め物をつめたもの")
], -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "InIIC"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "In の処置歯に虫歯がもう一度できてしまったした状態")
], -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "RF"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "白いプラスチックの詰め物　虫歯に歯と同色のつめものをしたもの")
], -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "RFIIC"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "RF の処置歯に虫歯がもう一度できてしまったした状態")
], -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "Ce"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "一時的にセメントを詰めた歯　セメントを暫間的につめたもの")
], -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "CeIIC"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "Ce の処置歯に虫歯がもう一度できてしまったした状態")
], -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "On"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "大きな金属の詰め物　Ｃ2以上の虫歯を修復したもの")
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "OnIIC"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "On の処置歯に虫歯がもう一度できてしまったした状態")
], -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "Cr"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "かぶせ物（冠）　虫歯に金属冠をかぶせたもの")
], -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "CrIIC"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "Cr の処置歯に虫歯がもう一度できてしまったした状態")
], -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "Br"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "歯が抜けた部分を両側の歯に橋のようにかぶせたもの　歯がないとき、両隣りまたは片隣りの歯に金属をかぶせて歯が抜けてしまったところを補ったもの")
], -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "BrIIC"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "Br の処置歯に虫歯がもう一度できてしまったした状態")
], -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "ダミー"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "ダミー　歯が抜けた部分を両側の歯に橋のようにかぶせたもので欠損した部分を補った人工歯（ダミーにはインプラントも含まれます）")
], -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "Jcr"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "ジャケット。かぶせ物（冠）　虫歯に、歯と同色の冠をかぶせたもの")
], -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "JcIIC"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "Jcr の処置歯に虫歯がもう一度できてしまったした状態")
], -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "Vcr"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "白い部分のあるかぶせ物　虫歯に金属で裏打ちをした歯と同色の冠をかぶせたもの")
], -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "VcIIC"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "Vcr の処置歯に虫歯がもう一度できてしまったした状態")
], -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "MB"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "見た目が自然な陶器と金属のかぶせ物　自然歯の色をした陶材を金属冠に焼き付けたもの")
], -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "MBIIC"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "MB の処置歯に虫歯がもう一度できてしまったした状態")
], -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "Post"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "前歯のさし歯　前歯の虫歯に、さし歯をしたもの")
], -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "PoIIC"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "Post の処置歯に虫歯がもう一度できてしまったした状態")
], -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "PD"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "部分入れ歯（部分入歯）　歯が残っていて欠損部に入歯をしたもの")
], -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "FD"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "総入れ歯（総入歯）　歯が全部なく、入歯したもの")
], -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "Tr"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "現在治療中の歯のこと")
], -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "17",
      height: "17",
      class: "m-0"
    }, [
      /*#__PURE__*/_createElementVNode("g", { transform: "scale(0.8)" }, [
        /*#__PURE__*/_createElementVNode("path", {
          fill: "none",
          stroke: "#000000",
          "stroke-miterlimit": "10",
          d: "M0.236,2.345c0,0,2.863-1.72,6.132-1.72 c3.27,0,6.796,1.72,6.796,1.72"
        }),
        /*#__PURE__*/_createElementVNode("line", {
          fill: "none",
          stroke: "#000000",
          "stroke-miterlimit": "10",
          x1: "4.328",
          y1: "2.682",
          x2: "2.453",
          y2: "11.775"
        }),
        /*#__PURE__*/_createElementVNode("line", {
          fill: "none",
          stroke: "#000000",
          "stroke-miterlimit": "10",
          x1: "7.328",
          y1: "2.682",
          x2: "5.453",
          y2: "11.775"
        }),
        /*#__PURE__*/_createElementVNode("line", {
          fill: "none",
          stroke: "#000000",
          "stroke-miterlimit": "10",
          x1: "10.328",
          y1: "2.682",
          x2: "8.453",
          y2: "11.775"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "智歯（親知らず）が歯肉の表面に正常に出ていないもの")
], -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "乳A～E、乳"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "乳歯（子どもの歯）")
], -1))
const _hoisted_87 = [
  _hoisted_46,
  _hoisted_47,
  _hoisted_48,
  _hoisted_49,
  _hoisted_50,
  _hoisted_51,
  _hoisted_52,
  _hoisted_53,
  _hoisted_54,
  _hoisted_55,
  _hoisted_56,
  _hoisted_57,
  _hoisted_58,
  _hoisted_59,
  _hoisted_60,
  _hoisted_61,
  _hoisted_62,
  _hoisted_63,
  _hoisted_64,
  _hoisted_65,
  _hoisted_66,
  _hoisted_67,
  _hoisted_68,
  _hoisted_69,
  _hoisted_70,
  _hoisted_71,
  _hoisted_72,
  _hoisted_73,
  _hoisted_74,
  _hoisted_75,
  _hoisted_76,
  _hoisted_77,
  _hoisted_78,
  _hoisted_79,
  _hoisted_80,
  _hoisted_81,
  _hoisted_82,
  _hoisted_83,
  _hoisted_84,
  _hoisted_85,
  _hoisted_86
]
const _hoisted_88 = { key: 1 }
const _hoisted_89 = { class: "teethTable" }
const _hoisted_90 = { class: "border-0" }
const _hoisted_91 = { class: "teethTable" }
const _hoisted_92 = { class: "border-0" }
const _hoisted_93 = {
  class: "text-center mt-3",
  style: {"margin-left":"11px"}
}
const _hoisted_94 = { class: "teethTable" }
const _hoisted_95 = { class: "border-0" }
const _hoisted_96 = { key: 2 }
const _hoisted_97 = { class: "teethTable" }
const _hoisted_98 = { class: "border-0" }
const _hoisted_99 = { class: "row" }
const _hoisted_100 = { class: "col-lg" }
const _hoisted_101 = { class: "card mt-2" }
const _hoisted_102 = { class: "card-header card-header-exam" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "exam-icon"
  }),
  /*#__PURE__*/_createTextVNode(" 歯周病（歯槽膿漏） ")
], -1))
const _hoisted_104 = {
  class: "position-absolute text-end pt-2 pe-2",
  style: {"top":"0px","left":"0px","width":"100%"}
}
const _hoisted_105 = { class: "card-body row gx-2" }
const _hoisted_106 = {
  key: 0,
  class: "table table-sm c-table-bordered"
}
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", {
    style: {"width":"200px"},
    class: "bg-light"
  }, "記号"),
  /*#__PURE__*/_createElementVNode("th", { class: "bg-light" }, "説明")
], -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "Ｐマイナス、Ｐ０～１、Ｐ１"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "正常")
], -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "Ｐ１～２、Ｐ２"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "歯を支えている骨が歯根の長さの３分の１程度まで消失したもの")
], -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "Ｐ２～３、Ｐ３"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "歯を支えている骨が歯根の長さの２分の１程度まで消失したもの")
], -1))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "Ｐ３～４、Ｐ４"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "歯を支えている骨が歯根の長さの３分の２程度まで消失したものもしくは、それ以上 と認めるもの")
], -1))
const _hoisted_112 = [
  _hoisted_107,
  _hoisted_108,
  _hoisted_109,
  _hoisted_110,
  _hoisted_111
]
const _hoisted_113 = { class: "col-6" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row flex-fill justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, "今回")
], -1))
const _hoisted_115 = {
  class: "table table-sm c-table-bordered",
  style: {"table-layout":"fixed"}
}
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "右上"),
  /*#__PURE__*/_createElementVNode("td", null, "上前歯"),
  /*#__PURE__*/_createElementVNode("td", null, "左上")
], -1))
const _hoisted_117 = ["textContent"]
const _hoisted_118 = ["textContent"]
const _hoisted_119 = ["textContent"]
const _hoisted_120 = ["textContent"]
const _hoisted_121 = ["textContent"]
const _hoisted_122 = ["textContent"]
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "右下"),
  /*#__PURE__*/_createElementVNode("td", null, "下前歯"),
  /*#__PURE__*/_createElementVNode("td", null, "左下")
], -1))
const _hoisted_124 = {
  key: 1,
  class: "col-6"
}
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row flex-fill justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, "前回")
], -1))
const _hoisted_126 = {
  class: "table table-sm c-table-bordered",
  style: {"table-layout":"fixed"}
}
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "右上"),
  /*#__PURE__*/_createElementVNode("td", null, "上前歯"),
  /*#__PURE__*/_createElementVNode("td", null, "左上")
], -1))
const _hoisted_128 = ["textContent"]
const _hoisted_129 = ["textContent"]
const _hoisted_130 = ["textContent"]
const _hoisted_131 = ["textContent"]
const _hoisted_132 = ["textContent"]
const _hoisted_133 = ["textContent"]
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "右下"),
  /*#__PURE__*/_createElementVNode("td", null, "下前歯"),
  /*#__PURE__*/_createElementVNode("td", null, "左下")
], -1))
const _hoisted_135 = { class: "col-lg" }
const _hoisted_136 = { class: "card mt-2" }
const _hoisted_137 = { class: "card-header card-header-exam" }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row h4 justify-content-center mb-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "exam-icon"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-start mt-2" }, [
    /*#__PURE__*/_createTextVNode("ＣＰＩＴＮ"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("（歯周ポケット測定）")
  ])
], -1))
const _hoisted_139 = {
  class: "position-absolute text-end pt-2 pe-2",
  style: {"top":"0px","left":"0px","width":"100%"}
}
const _hoisted_140 = { class: "card-body row gx-2" }
const _hoisted_141 = {
  key: 0,
  class: "table table-sm c-table-bordered"
}
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", {
    style: {"width":"50px"},
    class: "bg-light"
  }, "記号"),
  /*#__PURE__*/_createElementVNode("th", { class: "bg-light" }, "説明")
], -1))
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "0"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "歯ぐきが健康な状態（TYPE：０）")
], -1))
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "1"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "歯ぐきが少し赤くなった状態（TYPE：１）")
], -1))
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "2"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "歯石がついている状態（TYPE：２）")
], -1))
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "3"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "歯周病が少し進んでいる状態（TYPE：２）")
], -1))
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "4"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "歯周病がかなり進んでいる状態（TYPE：３）")
], -1))
const _hoisted_148 = [
  _hoisted_142,
  _hoisted_143,
  _hoisted_144,
  _hoisted_145,
  _hoisted_146,
  _hoisted_147
]
const _hoisted_149 = { class: "col-6" }
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row flex-fill justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, "今回")
], -1))
const _hoisted_151 = {
  class: "table c-table-bordered table-sm",
  style: {"table-layout":"fixed"}
}
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "右上"),
  /*#__PURE__*/_createElementVNode("td", { style: {"padding-left":"0px","padding-right":"0px"} }, "上前歯"),
  /*#__PURE__*/_createElementVNode("td", null, "左上"),
  /*#__PURE__*/_createElementVNode("td", null, "TYPE")
], -1))
const _hoisted_153 = ["textContent"]
const _hoisted_154 = ["textContent"]
const _hoisted_155 = ["textContent"]
const _hoisted_156 = ["textContent"]
const _hoisted_157 = ["textContent"]
const _hoisted_158 = ["textContent"]
const _hoisted_159 = ["textContent"]
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "右下"),
  /*#__PURE__*/_createElementVNode("td", { style: {"padding-left":"0px","padding-right":"0px"} }, "下前歯"),
  /*#__PURE__*/_createElementVNode("td", null, "左下")
], -1))
const _hoisted_161 = {
  key: 1,
  class: "col-6"
}
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row flex-fill justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, "前回")
], -1))
const _hoisted_163 = {
  class: "table c-table-bordered table-sm",
  style: {"table-layout":"fixed"}
}
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "右上"),
  /*#__PURE__*/_createElementVNode("td", { style: {"padding-left":"0px","padding-right":"0px"} }, "上前歯"),
  /*#__PURE__*/_createElementVNode("td", null, "左上"),
  /*#__PURE__*/_createElementVNode("td", null, "TYPE")
], -1))
const _hoisted_165 = ["textContent"]
const _hoisted_166 = ["textContent"]
const _hoisted_167 = ["textContent"]
const _hoisted_168 = ["textContent"]
const _hoisted_169 = ["textContent"]
const _hoisted_170 = ["textContent"]
const _hoisted_171 = ["textContent"]
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "右下"),
  /*#__PURE__*/_createElementVNode("td", { style: {"padding-left":"0px","padding-right":"0px"} }, "下前歯"),
  /*#__PURE__*/_createElementVNode("td", null, "左下")
], -1))
const _hoisted_173 = { class: "row" }
const _hoisted_174 = { class: "col-lg" }
const _hoisted_175 = { class: "card mt-2" }
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header card-header-exam" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h4" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_3,
      class: "exam-icon"
    }),
    /*#__PURE__*/_createTextVNode(" 特殊健診 ")
  ])
], -1))
const _hoisted_177 = { class: "card-body row" }
const _hoisted_178 = { class: "col-12" }
const _hoisted_179 = { class: "table c-table-bordered table-sm" }
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end border-start-0 border-end-0 border-top-0" }, null, -1))
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border-start-0 border-end-0 border-top-0" }, "今回", -1))
const _hoisted_182 = {
  key: 0,
  class: "border-start-0 border-end-0 border-top-0"
}
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "口腔粘膜", -1))
const _hoisted_184 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "酸蝕症度", -1))
const _hoisted_186 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_187 = { class: "col-lg" }
const _hoisted_188 = { class: "card mt-2" }
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header card-header-exam" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h4" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_4,
      class: "exam-icon"
    }),
    /*#__PURE__*/_createTextVNode(" う蝕歯（虫歯）等 ")
  ])
], -1))
const _hoisted_190 = { class: "card-body row" }
const _hoisted_191 = { class: "col-12" }
const _hoisted_192 = { class: "table c-table-bordered table-sm" }
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end border-start-0 border-end-0 border-top-0" }, null, -1))
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  style: {"width":"20%"},
  class: "border-start-0 border-end-0 border-top-0"
}, "今回", -1))
const _hoisted_195 = {
  key: 0,
  style: {"width":"20%"},
  class: "border-start-0 border-end-0 border-top-0"
}
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "text-start",
  style: {"width":"60%"}
}, "Ｃ1（初期う蝕）注意", -1))
const _hoisted_197 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "text-start",
  style: {"width":"60%"}
}, "Ｃ2（早期要治療）", -1))
const _hoisted_199 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "text-start",
  style: {"width":"60%"}
}, "Ｃ3（重度要治療）", -1))
const _hoisted_201 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "text-start",
  style: {"width":"60%"}
}, "Ｃ4（重度要治療）", -1))
const _hoisted_203 = {
  key: 0,
  style: {"width":"20%"},
  class: "bg-light text-gray"
}
const _hoisted_204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "text-start",
  style: {"width":"60%"}
}, "IIＣ（重度要治療）", -1))
const _hoisted_205 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_206 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "text-start",
  style: {"width":"60%"}
}, "脱（要相談歯）", -1))
const _hoisted_207 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "text-start",
  style: {"width":"60%"}
}, "Ｔｒ（治療途中歯）", -1))
const _hoisted_209 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_210 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "text-start",
  style: {"width":"60%"}
}, "×（欠損歯）", -1))
const _hoisted_211 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_212 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "text-start",
  style: {"width":"60%"}
}, "WSD（楔状欠損歯）", -1))
const _hoisted_213 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_214 = { class: "card mt-2" }
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header card-header-exam" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h4" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_5,
      class: "exam-icon"
    }),
    /*#__PURE__*/_createTextVNode(" 歯石沈着度および清掃状態 ")
  ])
], -1))
const _hoisted_216 = { class: "card-body row" }
const _hoisted_217 = { class: "col-12" }
const _hoisted_218 = { class: "table c-table-bordered table-sm" }
const _hoisted_219 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end border-start-0 border-end-0 border-top-0" }, null, -1))
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border-start-0 border-end-0 border-top-0" }, "今回", -1))
const _hoisted_221 = {
  key: 0,
  class: "border-start-0 border-end-0 border-top-0"
}
const _hoisted_222 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "歯石沈着度 ", -1))
const _hoisted_223 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_224 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "清掃状態", -1))
const _hoisted_225 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_226 = { class: "card mt-2" }
const _hoisted_227 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header card-header-exam" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h4" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_6,
      class: "exam-icon"
    }),
    /*#__PURE__*/_createTextVNode(" チャート ")
  ])
], -1))
const _hoisted_228 = { class: "card-body" }
const _hoisted_229 = { class: "row" }
const _hoisted_230 = { class: "col-sm-6 d-flex justify-content-center" }
const _hoisted_231 = { style: {"max-width":"500px"} }
const _hoisted_232 = { class: "col-sm-6 d-flex justify-content-center" }
const _hoisted_233 = { style: {"max-width":"500px"} }
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-footer bg-white" }, [
  /*#__PURE__*/_createTextVNode(" 上記図表は個人データを基にあたなの口腔状態をオリジナルにチャート化したものです。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("各項目とも平均値を上回るように正しい口腔管理を心掛けてください。 ")
], -1))
const _hoisted_235 = { key: 1 }
const _hoisted_236 = { class: "d-flex flex-row justify-content-center mb-3" }
const _hoisted_237 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ps-2 pe-2" }, "異常なし", -1))
const _hoisted_238 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ps-2 pe-2" }, "注意", -1))
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ps-2 pe-2" }, "早期治療", -1))
const _hoisted_240 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ps-2 pe-2" }, "要治療", -1))
const _hoisted_241 = { class: "card" }
const _hoisted_242 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-primary text-white" }, " 初期う蝕（注意） ", -1))
const _hoisted_243 = { class: "card mt-2" }
const _hoisted_244 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-primary text-white" }, " 早期要治療歯 ", -1))
const _hoisted_245 = { class: "card mt-2" }
const _hoisted_246 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-primary text-white" }, " 重度要治療歯 ", -1))
const _hoisted_247 = { class: "card mt-2" }
const _hoisted_248 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-primary text-white" }, " 欠損歯 ", -1))
const _hoisted_249 = { class: "card mt-2" }
const _hoisted_250 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-primary text-white" }, " 楔状欠損歯(WSD) ", -1))
const _hoisted_251 = { class: "card mt-2" }
const _hoisted_252 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-primary text-white" }, " 清掃状態 ", -1))
const _hoisted_253 = { class: "card mt-2" }
const _hoisted_254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-primary text-white" }, " 口腔粘膜 ", -1))
const _hoisted_255 = { key: 2 }
const _hoisted_256 = { class: "d-flex flex-row justify-content-center mb-3" }
const _hoisted_257 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ps-2 pe-2" }, "異常なし", -1))
const _hoisted_258 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ps-2 pe-2" }, "注意", -1))
const _hoisted_259 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ps-2 pe-2" }, "要治療", -1))
const _hoisted_260 = { class: "card" }
const _hoisted_261 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-primary text-white" }, " 右上 ", -1))
const _hoisted_262 = { class: "card mt-2" }
const _hoisted_263 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-primary text-white" }, " 上前歯 ", -1))
const _hoisted_264 = { class: "card mt-2" }
const _hoisted_265 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-primary text-white" }, " 左上 ", -1))
const _hoisted_266 = { class: "card" }
const _hoisted_267 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-primary text-white" }, " 右下 ", -1))
const _hoisted_268 = { class: "card mt-2" }
const _hoisted_269 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-primary text-white" }, " 下前歯 ", -1))
const _hoisted_270 = { class: "card mt-2" }
const _hoisted_271 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-primary text-white" }, " 左下 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_shishiki_component = _resolveComponent("shishiki-component")!
  const _component_teeth_exam = _resolveComponent("teeth-exam")!
  const _component_teeth_radar_chart = _resolveComponent("teeth-radar-chart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.currentKenshin.kenshinDate && _ctx.ready)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " 健診データがありません。 "))
      : _createCommentVNode("", true),
    (_ctx.currentKenshin.kenshinDate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("ul", _hoisted_3, [
            _createElementVNode("li", _hoisted_4, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", {active: _ctx.tabIndex===0, 'bg-light': _ctx.tabIndex===0}]),
                href: "#",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tabIndex=0))
              }, "健診結果", 2)
            ]),
            _createElementVNode("li", _hoisted_5, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", {active: _ctx.tabIndex===1, 'bg-light': _ctx.tabIndex===1}]),
                href: "#",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tabIndex=1))
              }, "詳細説明", 2)
            ]),
            _createElementVNode("li", _hoisted_6, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", {active: _ctx.tabIndex===2, 'bg-light': _ctx.tabIndex===2}]),
                href: "#",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tabIndex=2))
              }, "歯周病説明", 2)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("select", {
                style: {"width":"100px"},
                class: "form-select form-select-sm mb-1",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleChange($event)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kenshinList, (row, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    onSelect: ($event: any) => (_ctx.andleChange($event, index)),
                    value: row.kenshinDate,
                    key: index
                  }, _toDisplayString(_ctx.FU.datetimeFormat(row.kenshinDate, 'YYYY/MM/DD')), 41, _hoisted_8))
                }), 128))
              ], 32)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.tabIndex===0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, "歯科医師：" + _toDisplayString(_ctx.currentKenshin.ishiName), 1),
                      _createElementVNode("span", null, "衛生士：" + _toDisplayString(_ctx.currentKenshin.eiseishiName), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("span", {
                                    class: "btn btn-lg p-3 w-100",
                                    style: _normalizeStyle({'background-color': _ctx.SogoHantei.getEnum('' + _ctx.currentKenshin.sogoHantei).color})
                                  }, [
                                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.SogoHantei.getName('' + _ctx.currentKenshin.sogoHantei)), 1)
                                  ], 4)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.currentKenshin.sogoHanteiComment), 1)
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("img", {
                                class: "float-end img-fluid",
                                alt: "Vue logo",
                                src: require(`@/assets/exam_${_ctx.currentKenshin.sogoHantei}.png`)
                              }, null, 8, _hoisted_26)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              (_ctx.currentKenshin.suiteiNenrei!==null && _ctx.currentKenshin.suiteiNenrei!==undefined)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _createTextVNode(" あなたの歯科推定年齢は"),
                                    _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.FU.numberFormat(_ctx.currentKenshin.suiteiNenrei)), 1),
                                    _createTextVNode("歳です。 ")
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_35, " 今回の健診では歯科推定年齢を算出できませんでした。 ")),
                              (_ctx.existsPrev)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                    (_ctx.prevKenshin.suiteiNenrei!==null && _ctx.prevKenshin.suiteiNenrei!==undefined)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, " ※前回の健診では" + _toDisplayString(_ctx.FU.numberFormat(_ctx.prevKenshin.suiteiNenrei)) + "歳でした。 ", 1))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_38, " ※前回の健診では歯科推定年齢を算出できませんでした。 "))
                                  ]))
                                : _createCommentVNode("", true),
                              _hoisted_39
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("button", {
                          class: "btn btn-light",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showShishiDoc=!_ctx.showShishiDoc))
                        }, _toDisplayString(_ctx.showShishiDoc ? '閉じる' : '記号説明'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      (_ctx.showShishiDoc)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_45, _hoisted_87))
                        : _createCommentVNode("", true),
                      (_ctx.existsPrev)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                            _createTextVNode(" 前回 "),
                            _createElementVNode("div", _hoisted_89, [
                              _createElementVNode("div", _hoisted_90, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tns, (row, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "border-0 text-center",
                                    style: {"height":"10px!important"},
                                    key: index
                                  }, _toDisplayString(row), 1))
                                }), 128))
                              ]),
                              _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.upper, (row, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "display bg-light",
                                    key: index
                                  }, [
                                    _createVNode(_component_shishiki_component, {
                                      codes: _ctx.prevKenshin[row],
                                      "history-flg": "true"
                                    }, null, 8, ["codes"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _createTextVNode(" 今回 "),
                        _createElementVNode("div", _hoisted_91, [
                          _createElementVNode("div", _hoisted_92, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tns, (row, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "border-0 text-center",
                                style: {"height":"10px!important"},
                                key: index
                              }, _toDisplayString(row), 1))
                            }), 128))
                          ]),
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.upper, (row, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "shishiki-cell"
                              }, [
                                _createVNode(_component_shishiki_component, {
                                  codes: _ctx.currentKenshin[row],
                                  colors: _ctx.currentKenshin.shishikiUpperColor[index]
                                }, null, 8, ["codes", "colors"])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_93, [
                        _createVNode(_component_teeth_exam, {
                          "current-border-color": "ccc",
                          "current-label": "xxx",
                          "current-data": "[1,2,3]",
                          exams: _ctx.teethInfo
                        }, null, 8, ["exams"])
                      ]),
                      _createElementVNode("div", null, [
                        _createTextVNode(" 今回 "),
                        _createElementVNode("div", _hoisted_94, [
                          _createElementVNode("div", _hoisted_95, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tns, (row, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "border-0 text-center",
                                style: {"height":"10px!important"},
                                key: index
                              }, _toDisplayString(row), 1))
                            }), 128))
                          ]),
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lower, (row, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "shishiki-cell"
                              }, [
                                _createVNode(_component_shishiki_component, {
                                  codes: _ctx.currentKenshin[row],
                                  colors: _ctx.currentKenshin.shishikiLowerColor[index]
                                }, null, 8, ["codes", "colors"])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      (_ctx.existsPrev)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                            _createTextVNode(" 前回 "),
                            _createElementVNode("div", _hoisted_97, [
                              _createElementVNode("div", _hoisted_98, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tns, (row, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "border-0 text-center",
                                    style: {"height":"10px!important"},
                                    key: index
                                  }, _toDisplayString(row), 1))
                                }), 128))
                              ]),
                              _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lower, (row, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "display bg-light",
                                    key: index
                                  }, [
                                    _createVNode(_component_shishiki_component, {
                                      codes: _ctx.prevKenshin[row],
                                      "history-flg": "true"
                                    }, null, 8, ["codes"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("div", _hoisted_101, [
                        _createElementVNode("div", _hoisted_102, [
                          _hoisted_103,
                          _createElementVNode("div", _hoisted_104, [
                            _createElementVNode("button", {
                              class: "btn btn-light",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showNoroDoc=!_ctx.showNoroDoc))
                            }, _toDisplayString(_ctx.showNoroDoc ? '閉じる' : '記号説明'), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_105, [
                          (_ctx.showNoroDoc)
                            ? (_openBlock(), _createElementBlock("table", _hoisted_106, _hoisted_112))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_113, [
                            _hoisted_114,
                            _createElementVNode("table", _hoisted_115, [
                              _hoisted_116,
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(0)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getPHantei(0))
                                }, null, 12, _hoisted_117),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(1)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getPHantei(1))
                                }, null, 12, _hoisted_118),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(2)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getPHantei(2))
                                }, null, 12, _hoisted_119)
                              ]),
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(3)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getPHantei(3))
                                }, null, 12, _hoisted_120),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(4)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getPHantei(4))
                                }, null, 12, _hoisted_121),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(5)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getPHantei(5))
                                }, null, 12, _hoisted_122)
                              ]),
                              _hoisted_123
                            ])
                          ]),
                          (_ctx.existsPrev)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                _hoisted_125,
                                _createElementVNode("table", _hoisted_126, [
                                  _hoisted_127,
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getPHantei(0))
                                    }, null, 8, _hoisted_128),
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getPHantei(1))
                                    }, null, 8, _hoisted_129),
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getPHantei(2))
                                    }, null, 8, _hoisted_130)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getPHantei(3))
                                    }, null, 8, _hoisted_131),
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getPHantei(4))
                                    }, null, 8, _hoisted_132),
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getPHantei(5))
                                    }, null, 8, _hoisted_133)
                                  ]),
                                  _hoisted_134
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_135, [
                      _createElementVNode("div", _hoisted_136, [
                        _createElementVNode("div", _hoisted_137, [
                          _hoisted_138,
                          _createElementVNode("div", _hoisted_139, [
                            _createElementVNode("button", {
                              class: "btn btn-light",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showCpitnDoc=!_ctx.showCpitnDoc))
                            }, _toDisplayString(_ctx.showCpitnDoc ? '閉じる' : '記号説明'), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_140, [
                          (_ctx.showCpitnDoc)
                            ? (_openBlock(), _createElementBlock("table", _hoisted_141, _hoisted_148))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_149, [
                            _hoisted_150,
                            _createElementVNode("table", _hoisted_151, [
                              _hoisted_152,
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getCpitnColor(0)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getCpitn(0))
                                }, null, 12, _hoisted_153),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getCpitnColor(1)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getCpitn(1))
                                }, null, 12, _hoisted_154),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getCpitnColor(2)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getCpitn(2))
                                }, null, 12, _hoisted_155),
                                _createElementVNode("td", {
                                  rowspan: "3",
                                  class: "align-middle",
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.typeIroKbn)}),
                                  textContent: _toDisplayString(_ctx.currentKenshin.type)
                                }, null, 12, _hoisted_156)
                              ]),
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getCpitnColor(3)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getCpitn(3))
                                }, null, 12, _hoisted_157),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getCpitnColor(4)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getCpitn(4))
                                }, null, 12, _hoisted_158),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getCpitnColor(5)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getCpitn(5))
                                }, null, 12, _hoisted_159)
                              ]),
                              _hoisted_160
                            ])
                          ]),
                          (_ctx.existsPrev)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                                _hoisted_162,
                                _createElementVNode("table", _hoisted_163, [
                                  _hoisted_164,
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getCpitn(0))
                                    }, null, 8, _hoisted_165),
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getCpitn(1))
                                    }, null, 8, _hoisted_166),
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getCpitn(2))
                                    }, null, 8, _hoisted_167),
                                    _createElementVNode("td", {
                                      rowspan: "3",
                                      class: "align-middle bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshin.type)
                                    }, null, 8, _hoisted_168)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getCpitn(3))
                                    }, null, 8, _hoisted_169),
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getCpitn(4))
                                    }, null, 8, _hoisted_170),
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getCpitn(5))
                                    }, null, 8, _hoisted_171)
                                  ]),
                                  _hoisted_172
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_173, [
                    _createElementVNode("div", _hoisted_174, [
                      _createElementVNode("div", _hoisted_175, [
                        _hoisted_176,
                        _createElementVNode("div", _hoisted_177, [
                          _createElementVNode("div", _hoisted_178, [
                            _createElementVNode("table", _hoisted_179, [
                              _createElementVNode("tr", null, [
                                _hoisted_180,
                                _hoisted_181,
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_182, "前回"))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_183,
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.kokuNenmakuIroKbn)})
                                }, _toDisplayString(_ctx.kenshinService.getTokushuKenshinName(_ctx.currentKenshin.kokuNenmaku)), 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_184, _toDisplayString(_ctx.kenshinService.getTokushuKenshinName(_ctx.prevKenshin.kokuNenmaku)), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_185,
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.sanshokuShodoIroKbn)})
                                }, _toDisplayString(_ctx.kenshinService.getTokushuKenshinName(_ctx.currentKenshin.sanshokuShodo)), 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_186, _toDisplayString(_ctx.kenshinService.getTokushuKenshinName(_ctx.prevKenshin.sanshokuShodo)), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_187, [
                      _createElementVNode("div", _hoisted_188, [
                        _hoisted_189,
                        _createElementVNode("div", _hoisted_190, [
                          _createElementVNode("div", _hoisted_191, [
                            _createElementVNode("table", _hoisted_192, [
                              _createElementVNode("tr", null, [
                                _hoisted_193,
                                _hoisted_194,
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_195, "前回"))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_196,
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.c1IroKbn)})
                                }, _toDisplayString(_ctx.currentKenshin.c1Honsu) + "本", 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_197, _toDisplayString(_ctx.prevKenshin.c1Honsu) + "本", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_198,
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.c2IroKbn)})
                                }, _toDisplayString(_ctx.currentKenshin.c2Honsu) + "本", 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_199, _toDisplayString(_ctx.prevKenshin.c2Honsu) + "本", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_200,
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.c3IroKbn)})
                                }, _toDisplayString(_ctx.currentKenshin.c3Honsu) + "本", 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_201, _toDisplayString(_ctx.prevKenshin.c3Honsu) + "本", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_202,
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.c4IroKbn)})
                                }, _toDisplayString(_ctx.currentKenshin.c4Honsu) + "本", 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_203, _toDisplayString(_ctx.prevKenshin.c4Honsu) + "本", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_204,
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.iicIroKbn)})
                                }, _toDisplayString(_ctx.currentKenshin.iicHonsu) + "本", 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_205, _toDisplayString(_ctx.prevKenshin.iicHonsu) + "本", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_206,
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.datsurakuIroKbn)})
                                }, _toDisplayString(_ctx.currentKenshin.datsurakuHonsu) + "本", 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_207, _toDisplayString(_ctx.prevKenshin.datsurakuHonsu) + "本", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_208,
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.trIroKbn)})
                                }, _toDisplayString(_ctx.currentKenshin.trHonsu) + "本", 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_209, _toDisplayString(_ctx.prevKenshin.trHonsu) + "本", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_210,
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.yohotetsushiIroKbn)})
                                }, _toDisplayString(_ctx.currentKenshin.yohotetsushi) + "本", 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_211, _toDisplayString(_ctx.prevKenshin.yohotetsushi) + "本", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_212,
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.wsdIroKbn)})
                                }, _toDisplayString(_ctx.currentKenshin.wsdHonsu) + "本", 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_213, _toDisplayString(_ctx.prevKenshin.wsdHonsu) + "本", 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_214, [
                    _hoisted_215,
                    _createElementVNode("div", _hoisted_216, [
                      _createElementVNode("div", _hoisted_217, [
                        _createElementVNode("table", _hoisted_218, [
                          _createElementVNode("tr", null, [
                            _hoisted_219,
                            _hoisted_220,
                            (_ctx.existsPrev)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_221, "前回"))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_222,
                            _createElementVNode("td", {
                              style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.shisekiChinchakuIroKbn)})
                            }, _toDisplayString(_ctx.kenshinService.getShisekiChinchakudoName(_ctx.currentKenshin.shisekiChinchaku)), 5),
                            (_ctx.existsPrev)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_223, _toDisplayString(_ctx.prevKenshinService.getShisekiChinchakudoName(_ctx.prevKenshin.shisekiChinchaku)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_224,
                            _createElementVNode("td", {
                              style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.seisoJotaiIroKbn)})
                            }, _toDisplayString(_ctx.kenshinService.getSeisoJotaiName(_ctx.currentKenshin.seisoJotai)), 5),
                            (_ctx.existsPrev)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_225, _toDisplayString(_ctx.prevKenshinService.getSeisoJotaiName(_ctx.prevKenshin.seisoJotai)), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_226, [
                    _hoisted_227,
                    _createElementVNode("div", _hoisted_228, [
                      _createElementVNode("div", _hoisted_229, [
                        _createElementVNode("div", _hoisted_230, [
                          _createElementVNode("div", _hoisted_231, [
                            true
                              ? (_openBlock(), _createBlock(_component_teeth_radar_chart, {
                                  key: 0,
                                  "current-data": [_ctx.currentKenshin.shisekiDev, _ctx.currentKenshin.pMaxDev, _ctx.currentKenshin.typeDev,
                  _ctx.currentKenshin.kessonshiDev, _ctx.currentKenshin.wsdDev, _ctx.currentKenshin.ushokushiDev],
                                  "current-label": "今回",
                                  "current-border-color": "lightblue"
                                }, null, 8, ["current-data"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_232, [
                          _createElementVNode("div", _hoisted_233, [
                            (_ctx.existsPrev)
                              ? (_openBlock(), _createBlock(_component_teeth_radar_chart, {
                                  key: 0,
                                  "current-data": [_ctx.prevKenshin.shisekiDev, _ctx.prevKenshin.pMaxDev, _ctx.prevKenshin.typeDev,
                  _ctx.prevKenshin.kessonshiDev, _ctx.prevKenshin.wsdDev, _ctx.prevKenshin.ushokushiDev],
                                  "current-label": "前回",
                                  "current-border-color": "lightsalmon"
                                }, null, 8, ["current-data"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_234
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.tabIndex===1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_235, [
                  _createElementVNode("div", _hoisted_236, [
                    _createElementVNode("div", {
                      class: "border-1 border",
                      style: _normalizeStyle([{"width":"18px"}, {'background-color': _ctx.iroKbnMap.get('1')}])
                    }, null, 4),
                    _hoisted_237,
                    _createElementVNode("div", {
                      class: "border-1 border",
                      style: _normalizeStyle([{"width":"18px"}, {'background-color': _ctx.iroKbnMap.get('2')}])
                    }, null, 4),
                    _hoisted_238,
                    _createElementVNode("div", {
                      class: "border-1 border",
                      style: _normalizeStyle([{"width":"18px"}, {'background-color': _ctx.iroKbnMap.get('3')}])
                    }, null, 4),
                    _hoisted_239,
                    _createElementVNode("div", {
                      class: "border-1 border",
                      style: _normalizeStyle([{"width":"18px"}, {'background-color': _ctx.iroKbnMap.get('4')}])
                    }, null, 4),
                    _hoisted_240
                  ]),
                  _createElementVNode("div", _hoisted_241, [
                    _hoisted_242,
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.iroKbnMap.get(_ctx.currentKenshin.ushoku1IroKbn)})
                    }, _toDisplayString(_ctx.currentKenshin.ushoku1Comment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_243, [
                    _hoisted_244,
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.iroKbnMap.get(_ctx.currentKenshin.ushoku2IroKbn)})
                    }, _toDisplayString(_ctx.currentKenshin.ushoku2Comment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_245, [
                    _hoisted_246,
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.iroKbnMap.get(_ctx.currentKenshin.ushoku3IroKbn)})
                    }, _toDisplayString(_ctx.currentKenshin.ushoku3Comment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_247, [
                    _hoisted_248,
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.iroKbnMap.get(_ctx.currentKenshin.yohotetsushiIroKbn)})
                    }, _toDisplayString(_ctx.currentKenshin.kessonshiComment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_249, [
                    _hoisted_250,
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.iroKbnMap.get(_ctx.currentKenshin.wsdIroKbn)})
                    }, _toDisplayString(_ctx.currentKenshin.wsdComment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_251, [
                    _hoisted_252,
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.iroKbnMap.get(_ctx.currentKenshin.seisoJotaiIroKbn)})
                    }, _toDisplayString(_ctx.currentKenshin.seisoJotaiComment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_253, [
                    _hoisted_254,
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.iroKbnMap.get(_ctx.currentKenshin.kokuNenmakuIroKbn)})
                    }, _toDisplayString(_ctx.currentKenshin.kokuNenmakuComment), 5)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.tabIndex===2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_255, [
                  _createElementVNode("div", _hoisted_256, [
                    _createElementVNode("div", {
                      class: "border-1 border",
                      style: _normalizeStyle([{"width":"18px"}, {'background-color': _ctx.iroKbnMap.get('1')}])
                    }, null, 4),
                    _hoisted_257,
                    _createElementVNode("div", {
                      class: "border-1 border",
                      style: _normalizeStyle([{"width":"18px"}, {'background-color': _ctx.iroKbnMap.get('2')}])
                    }, null, 4),
                    _hoisted_258,
                    _createElementVNode("div", {
                      class: "border-1 border",
                      style: _normalizeStyle([{"width":"18px"}, {'background-color': _ctx.iroKbnMap.get('4')}])
                    }, null, 4),
                    _hoisted_259
                  ]),
                  _createElementVNode("div", _hoisted_260, [
                    _hoisted_261,
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(0)})
                    }, _toDisplayString(_ctx.currentKenshin.pHantei1Comment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_262, [
                    _hoisted_263,
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(1)})
                    }, _toDisplayString(_ctx.currentKenshin.pHantei2Comment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_264, [
                    _hoisted_265,
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(2)})
                    }, _toDisplayString(_ctx.currentKenshin.pHantei3Comment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_266, [
                    _hoisted_267,
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(3)})
                    }, _toDisplayString(_ctx.currentKenshin.pHantei4Comment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_268, [
                    _hoisted_269,
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(4)})
                    }, _toDisplayString(_ctx.currentKenshin.pHantei5Comment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_270, [
                    _hoisted_271,
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(5)})
                    }, _toDisplayString(_ctx.currentKenshin.pHantei6Comment), 5)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}